import {
  CABIN_TYPE,
  formatTripType,
  SEARCH_SOURCE
} from "@website/ticket-ui/common/helper/tracking";
import { QueryParameters } from "@website/ticket-ui/common/tracking/types";
import { FlightProductType } from "@website/ticket-ui/common/types/tracking";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { daysBetweenDates } from "@website/utils/date-format";

export function addStSearchInitiatedEvent(
  query: QueryParameters,
  product: FlightProductType,
  isBestPrice?: boolean
) {
  const {
    adultCount,
    dateType,
    departureDate,
    cabinType,
    childCount,
    destination,
    destinationIsCity,
    originIsCity,
    destination_city,
    returnDate,
    origin_city,
    origin_is_city,
    destination_is_city,
    infantCount,
    source,
    origin
  } = query ?? {};

  const today = new Date();
  const departureDateObject = new Date(departureDate);
  const isRoundTrip = Boolean(returnDate);

  addEventToTracking(USER_TRACKING_EVENTS.GENERAL_SEARCH, {
    product,
    departure_date: departureDate ? new Date(departureDate) : undefined,
    return_departure_date: returnDate ? new Date(returnDate) : undefined,
    cabin_type: CABIN_TYPE[cabinType as keyof typeof CABIN_TYPE] ?? undefined,
    origin_city: origin_city?.replace(" ", "-"),
    destination_city: destination_city?.replace(" ", "-"),
    origin_is_city: origin_is_city !== "false",
    destination_is_city: destination_is_city !== "false",
    origin_airport:
      origin_is_city === "false" || originIsCity === "false"
        ? origin
        : "All Airport",
    destination_airport:
      destination_is_city === "false" || destinationIsCity === "false"
        ? destination
        : "All Airport",
    search_calendar_type: dateType,
    trip_type: formatTripType(isRoundTrip),

    number_of_passengers:
      Number(adultCount) + Number(childCount) + Number(infantCount) || 1,
    route: `${origin_city?.replace(" ", "-")} - ${destination_city?.replace(
      " ",
      "-"
    )}`,
    search_source:
      SEARCH_SOURCE[source as keyof typeof SEARCH_SOURCE] ?? undefined,
    search_window: daysBetweenDates(today, departureDateObject),
    is_price_table_best_price:
      source === "price_table" && typeof isBestPrice === "boolean"
        ? isBestPrice
        : undefined
  });
}
